import { CssGrid, GapSize, Orientation } from "../components/cssGrid";
import { Modal, ModalGridButton } from "../components/modal";
import { useIsMobile } from "../hooks/useResponsiveBreakpoint";

export const LicenseModal = ({
    onClose,
}: {
    onClose: () => void;
}): JSX.Element => {
    const isMobile = useIsMobile();

    const licenses = [
        {
            name: "Emulator Core (nanuboy)",
            license: "Apache License 2.0",
            text: `Copyright 2024 nanuboy contributors

Based on Retro Boy (Apache License 2.0)
Copyright (c) 2023 smparsons

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.`,
        },
        {
            name: "hUGEDriver",
            license: "MIT License",
            text: `Copyright (c) 2020 superpachi

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.`,
        },
        {
            name: "React, MUI, and other libraries",
            license: "MIT / Apache 2.0",
            text: "This project uses various open-source libraries including React, Material UI, and others under their respective MIT and Apache 2.0 licenses.",
        },
    ];

    return (
        <Modal heading="Licenses" open={true} onClose={onClose}>
            <CssGrid orientation={Orientation.vertical} gap={GapSize.large}>
                <div
                    style={{
                        maxHeight: "400px",
                        overflowY: "auto",
                        paddingRight: "8px",
                        fontSize: "14px",
                        color: "rgba(255, 255, 255, 0.8)",
                        textAlign: "left",
                    }}
                >
                    {licenses.map((lib, i) => (
                        <div key={i} style={{ marginBottom: "24px" }}>
                            <div
                                style={{
                                    fontWeight: "bold",
                                    borderBottom:
                                        "1px solid rgba(255, 255, 255, 0.1)",
                                    marginBottom: "8px",
                                    paddingBottom: "4px",
                                }}
                            >
                                {lib.name} ({lib.license})
                            </div>
                            <pre
                                style={{
                                    whiteSpace: "pre-wrap",
                                    margin: 0,
                                    fontFamily: "monospace",
                                    fontSize: "12px",
                                    opacity: 0.8,
                                }}
                            >
                                {lib.text}
                            </pre>
                        </div>
                    ))}
                </div>
                <ModalGridButton
                    variant="contained"
                    color="primary"
                    onClick={onClose}
                    isMobile={isMobile}
                >
                    Close
                </ModalGridButton>
            </CssGrid>
        </Modal>
    );
};
